import { Component, OnInit } from '@angular/core';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { MainserviceService } from '../service/mainservice.service';
import { User } from '../model/User.model';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { PaymentIntegration } from '../model/PaymentIntegration.model';
import { ReceiptMaster } from '../model/ReceiptMaster.model';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2'
// import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.component.html',
  styleUrls: ['./student-profile.component.scss']
})

export class StudentProfileComponent implements OnInit {
  cities: any[];
  selectedCity: any;
  displaystudentprofile: boolean = false;
  user: User = new User();
  studentMaster: StudentMaster = new StudentMaster();
  enrollCourseMasterList: EnrollCourseMaster[] = [];
  enrollCourseMaster: EnrollCourseMaster = new EnrollCourseMaster();
  paymentIntegration: PaymentIntegration = new PaymentIntegration();
  receiptMasterList: ReceiptMaster[] = [];
  editStudentProfile: boolean = false;
  opensocialdiv: boolean = false;
  currentPassword: boolean = false;
  currentStatus: boolean = false;
  newPassword: boolean = false;
  newStatus: boolean = false;
  confirmnewPassword: boolean = false;
  confirmnewStatus: boolean = false;
  changePassworddialog: boolean = false;
  constructor(private authService: AuthService, private router: Router, private mainService: MainserviceService) { }

  ngOnInit() {
    this.cities = [
      { name: 'New York', code: 'NY' },
      { name: 'Rome', code: 'RM' },
      { name: 'London', code: 'LDN' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' }
    ];
    this.studentMaster = this.mainService.getstudentSession();

    this.getEnrollCourse();
  }
  viewStudentProfile() {
    this.displaystudentprofile = true;
  }
  getEnrollCourse() {


    this.studentMaster.studentMasterId = this.user.id;


  }
  payPendingReceipt() {


    let enrollCourseMasterTemp: EnrollCourseMaster = new EnrollCourseMaster();
    enrollCourseMasterTemp.receiptMasterList = this.receiptMasterList;
    enrollCourseMasterTemp.studentMaster = new StudentMaster();
    enrollCourseMasterTemp.studentMaster.studentMasterId = this.user.id;
    this.mainService.payPendingReceipts(enrollCourseMasterTemp).subscribe(data => {
      this.paymentIntegration = data;
    })
  }
  openEditStudent() {
    this.editStudentProfile = true;
  }
  updateStudentDetails() {
    let user: User = new User();

    this.studentMaster.studentMasterId = user.id;

    this.mainService.updateStudentDetail(this.studentMaster).subscribe(data => {

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;

        if (jsonString == "SUCCESS") {
          this.editStudentProfile = false;
          Swal.fire({
            title: 'Success',
            text: 'Profile Update SuccessFully!',
            icon: 'success',
            showCancelButton: true,
          })

          this.mainService.setstudentSession(this.studentMaster);
        }

      }
    })
  }

  ChnageStudentPassword() {
    if (this.user.newPassword != this.user.confirmPassword) {
      Swal.fire({
        title: 'Error',
        text: 'New password & Current Password does not match!',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: true,
      })
      return;

    }
    if (this.user.username === null || this.user.username === undefined || this.user.username === "") {
      Swal.fire({
        title: 'error',
        text: 'Name Required!',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: true,
      })
      return;
    }
    if (this.user.currentPassword === null || this.user.currentPassword === undefined || this.user.currentPassword === "") {
      Swal.fire({
        title: 'error',
        text: 'currentPassword Required!',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: true,
      })
      return;
    }
    if (this.user.newPassword === null || this.user.newPassword === undefined || this.user.newPassword === "") {
      Swal.fire({
        title: 'error',
        text: 'newPassword Required!',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: true,
      })
      return;
    }
    if (this.user.confirmPassword === null || this.user.confirmPassword === undefined || this.user.confirmPassword === "") {
      Swal.fire({
        title: 'error',
        text: 'confirmPassword Required!',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: true,
      })
      return;
    }
    this.authService.changePassword(this.user).subscribe(data => {

      // this.user.password= this.user.newPassword;

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {

        // this.user = new User();

        let jsonString = err.error.text;

        if (jsonString == "SUCCESS") {
          Swal.fire({
            title: 'Success',
            text: 'Password Change SuccessFully!',
            icon: 'success',
            showCancelButton: true,
            showConfirmButton: true,
          })
          this.user.confirmPassword = "";
          this.user.newPassword = "";
          this.user.currentPassword = "";
          this.changePassworddialog = false;
          // this.user = new User();
        }
        else if (jsonString == "INCORRECT") {
          Swal.fire({
            title: 'Error',
            text: 'Current Password Wrong',
            icon: 'error',
            showCancelButton: true,
            showConfirmButton: true,
          })

        }

      }
    })
  }
  togglecurrentPass() {
    if (this.currentPassword) {
      this.currentPassword = false;
    }
    else {
      this.currentPassword = true;

    }
  }
  currentclickEvent() {
    this.currentStatus = !this.currentStatus;
  }

  togglenewPass() {
    if (this.newPassword) {
      this.newPassword = false;
    }
    else {
      this.newPassword = true;

    }
  }
  newclickEvent() {
    this.newStatus = !this.newStatus;
  }

  toggleConfirmPass() {
    if (this.confirmnewPassword) {
      this.confirmnewPassword = false;
    }
    else {
      this.confirmnewPassword = true;

    }
  }
  confirmclickEvent() {
    this.confirmnewStatus = !this.confirmnewStatus;
  }
  textcopied() {
    // alert("copied");
    // this.messageService.add({severity:'success', summary: 'Referral Code Copied!!'});
  }
  openChangePasswordModal() {
    this.changePassworddialog = true;
  }

}
